import { lazy } from 'react';

const GatesConsensusReport = lazy(() =>
  import('../../../screen/PrivateReport/GatesConsensusReport')
);

export { GatesConsensusReport };
